// 封装基础组件Loading-more
import LoadingMore from './loading-more.vue'

export default LoadingMore
